module.exports = __webpack_public_path__ + "static/media/ScrollBarUp.9760d617.svg";